// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-7c23a5":"17945fdecdff4a07","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"a97e63502cf91bd2","apps_bom_src_app_offer_offer-wrapper_module_ts":"d37fa0b2b0f6d858"}[chunkId] + ".js";
};